import UserSelectProvider from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { RolesTableProvider } from './RolesTableContext'
import RolesTabs from './components/RolesTabs'

const Roles: React.FC = () => (
  <RolesTableProvider>
    <UserSelectProvider>
      <RolesTabs />
    </UserSelectProvider>
  </RolesTableProvider>
)

export default Roles
